import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Layers } from "lucide-react";
import { api } from "@/lib/api";
import { BookCard, EmptyState } from "@/components/cards";

export default function SeriesDetail() {
  const { slug } = useParams();
  const [s, setS] = useState(null);
  useEffect(() => { api.get(`/series/${slug}`).then((r) => setS(r.data)).catch(() => setS(false)); }, [slug]);
  if (s === false) return <div className="py-24 text-center text-muted-foreground">Series not found.</div>;
  if (!s) return <div className="py-24 text-center text-muted-foreground">Loading…</div>;
  return (
    <div className="fade-in">
      <div className="relative h-64 overflow-hidden">
        {s.cover && <img src={s.cover} alt="" className="absolute inset-0 h-full w-full object-cover" />}
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/70 to-black/40" />
        <div className="relative max-w-[1400px] mx-auto px-4 lg:px-8 h-full flex flex-col justify-end pb-8">
          <p className="track-label text-xs text-primary flex items-center gap-2"><Layers className="h-4 w-4" /> Series</p>
          <h1 className="text-4xl md:text-5xl font-display font-bold mt-2">{s.name}</h1>
          {s.author && <Link to={`/authors/${s.author.slug}`} className="text-muted-foreground mt-1 hover:text-primary">by {s.author.name}</Link>}
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-10">
        <p className="text-muted-foreground max-w-2xl">{s.description}</p>
        <p className="text-sm text-muted-foreground mt-6 mb-4">{s.books.length} books in order</p>
        {s.books.length ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {s.books.map((b) => <div key={b.id}><span className="text-xs text-primary track-label">Book {b.book_number}</span><div className="mt-1"><BookCard book={b} /></div></div>)}
          </div>
        ) : <EmptyState title="No books in this series yet" />}
      </div>
    </div>
  );
}
